import { createContext, useContext, useState, useEffect } from "react";

export const translations = {
  tr: {
    nav: {
      features: "Özellikler",
      modules: "Modüller",
      pricing: "Fiyatlandırma",
      blog: "Blog",
      faq: "SSS",
      online: "Web Şube",
      login: "Giriş Yap",
      register: "Kayıt Ol",
    },
    segments: { individual: "Bireysel & İşletme", corporate: "Kurumsal" },
    hero: {
      overline: "PARASYO · FİNANS ASİSTANI",
      line1: "Kişisel bütçe, ev ve iş",
      line2: "finans asistanı.",
      sub: "Kişisel bütçe, ev (Home+) ve işletme finansı tek uygulamada. Hesaplar, bütçe, stok, teklif ve raporlar — 7/24 canlı destekle.",
      slide2: {
        line1: "Bireysel ve işletme,",
        line2: "tek platform.",
        desc: "ParasyoFree'dan Pro'ya — bireysel finans, Home+ ve işletme operasyonu tek hesapta. Kayıt akışında yalnızca Bireysel & İşletme veya Kurumsal seçin.",
        cta: "Özellikleri Keşfet",
      },
      ctaPrimary: "Ücretsiz Başla",
      ctaSecondary: "Parasyo'yu Tanı",
      note: "Kredi kartı gerekmez · Dilediğin an yükselt",
      stats: [
        { value: "12.000+", label: "aktif işletme" },
        { value: "%99,9", label: "çalışma süresi" },
        { value: "7/24", label: "canlı destek" },
      ],
      card: {
        title: "Nakit Akışı",
        month: "Temmuz 2026",
        income: "Gelir",
        expense: "Gider",
        balance: "Net Bakiye",
      },
    },
    marquee: [
      "GELİR GİDER TAKİBİ",
      "STOK YÖNETİMİ",
      "HIZLI SATIŞ (POS)",
      "DÖVİZ HESAPLARI",
      "ÇEK / SENET TAKİBİ",
      "PERSONEL & İK",
      "RAPORLAR & EKSTRE",
      "7/24 DESTEK",
      "E-FATURA (YAKINDA)",
    ],
    manifesto: {
      kicker: "MANİFESTO",
      title: "Muhasebe bir yük değil, bir görünürlük meselesidir.",
      body: "Parasyo; gelir-giderden stoğa, personelden teklife işletmenizin finansal operasyonunu tek ekranda toplar. Web'de ve mobilde çalışır, kredi kartı istemeden ücretsiz başlarsınız, dilediğiniz an yükseltirsiniz.",
    },
    features: {
      kicker: "ÖZELLİKLER",
      title: "İşletmenizin kalbi,",
      titleAccent: "tek platformda.",
      sub: "Sekiz güçlü modül. Tek platform. Sıfır karmaşa.",
      sub_individual: "Serbest çalışanlar ve şahıs işletmeleri için sade, güçlü araçlar.",
      sub_corporate: "Ekipler ve büyüyen işletmeler için Pro ile tam kontrol.",
      soon: "YAKINDA",
      detail: "Detaylı İncele",
      items: [
        { no: "01", title: "Ön Muhasebe", desc: "Cari hesaplar, kasa ve banka hareketleri, tahsilat ve ödeme takibi. İşletmenizin finansal kalbi, her an güncel." },
        { no: "02", title: "Gelir-Gider Takibi", desc: "Kategori bazlı gelir-gider analizi, dönemsel karşılaştırmalar ve nakit akışı öngörüleri." },
        { no: "03", title: "Stok Yönetimi", desc: "Kritik stok uyarıları, depo bazlı takip ve otomatik sayım raporları." },
        { no: "04", title: "CRM", desc: "Müşteri geçmişi, satış hunisi ve iletişim kayıtları tek kartta birleşir." },
        { no: "05", title: "İnsan Kaynakları", desc: "Personel özlük dosyaları, izin takibi ve bordro ön hazırlığı." },
        { no: "06", title: "Belge Yönetimi", desc: "Sözleşme, makbuz ve evraklarınız etiketli, aranabilir ve güvende." },
        { no: "07", title: "Teklif Yönetimi", desc: "Dakikalar içinde profesyonel teklifler hazırlayın, onay sürecini izleyin." },
        { no: "08", title: "7/24 Canlı Destek", desc: "Gerçek insanlar, gerçek zamanlı yanıtlar. Gece üçünde bile." },
      ],
    },
    modules: {
      kicker: "GERÇEK EKRANLAR",
      rows: [
        {
          tag: "01 — KASA, BANKA VE CARİ",
          title: "Tüm para hareketi tek ekranda.",
          desc: "Sınırsız kasa ve banka hesabı, döviz hesaplarında TCMB kurlarıyla otomatik TL karşılığı, çek/senet takibi ve salt okunur ekstre paylaşımı.",
          points: ["Döviz hesapları + çapraz kur transferi", "Çek/senet vade takibi", "Salt okunur paylaşım linkleri"],
          img: "web-kasa-banka",
          alt: "Parasyo kasa ve banka ekranı",
          slug: "on-muhasebe",
        },
        {
          tag: "02 — FATURA VE TEKLİF",
          title: "Faturalar kayıtlı, teklifler takipte.",
          desc: "Gelen ve giden faturaların kaydı, ödeme durumu takibi; müşteriye özel teklif hazırlama ve onay süreci izleme.",
          points: ["Fatura kaydı ve durum takibi", "Tekliften satışa dönüşüm", "Tedarikçi ve proje bağlantısı"],
          img: "web-faturalar",
          alt: "Parasyo faturalar ekranı",
          slug: "teklif-yonetimi",
        },
        {
          tag: "03 — STOK YÖNETİMİ",
          title: "Kritik stok, gözünüzün önünde.",
          desc: "Ürün kartları, çoklu depo, stok hareketleri ve kritik stok uyarısı. Marka ve kategori sözlüğüyle bir kez yazın, sonra listeden seçin.",
          points: ["Kritik stok uyarıları", "Çoklu depo ve hareket geçmişi", "Marka/kategori sözlüğü"],
          img: "web-stok",
          alt: "Parasyo stok yönetimi ekranı",
          slug: "stok-yonetimi",
        },
        {
          tag: "04 — HIZLI SATIŞ (POS)",
          title: "Tezgâh üstü satış saniyeler sürer.",
          desc: "Barkodlu satış, kasa aç/kapat, veresiye ve gün sonu. Premium ve Pro paketlerine dahildir.",
          points: ["Barkodla hızlı satış", "Kasa açılış/kapanış kontrolü", "Veresiye tahsilatı"],
          img: "web-pos",
          phone: "mobil-pos",
          alt: "Parasyo hızlı satış POS ekranı",
          slug: "hizli-satis",
        },
        {
          tag: "05 — PERSONEL, İK+ VE PDKS",
          title: "Ekibinizin kaydı düzenli.",
          desc: "Personel kartları, maaş ve ödeme günü takibi; Pro paketindeki PDKS ile giriş-çıkış ve puantaj.",
          points: ["Personel kartları ve maaş günü", "PDKS giriş-çıkış ve puantaj", "İK+ gelişmiş personel yönetimi"],
          img: "web-personel",
          alt: "Parasyo personel yönetimi ekranı",
          slug: "insan-kaynaklari",
        },
        {
          tag: "06 — RAPORLAR VE ÇEK/SENET",
          title: "Kararlar veriye dayanır.",
          desc: "Dönemsel raporlar, ekstre indirme ve çek/senet portföyünüzün vade görünümü.",
          points: ["Rapor ve ekstre indirme", "Çek/senet vade takvimi", "Dönemsel karşılaştırmalar"],
          img: "web-raporlar",
          alt: "Parasyo raporlar ekranı",
          slug: "gelir-gider-takibi",
        },
        {
          tag: "07 — CRM",
          title: "Müşterinin hikâyesi tek kartta.",
          desc: "Pro'ya dahil Detaylı CRM ile müşteri kartları, satış takibi ve hatırlatmalar.",
          points: ["360° müşteri kartı", "Satış takibi", "Otomatik hatırlatmalar"],
          img: "web-crm",
          alt: "Parasyo CRM ekranı",
          slug: "crm",
        },
      ],
    },
    mobile: {
      kicker: "MOBİL UYGULAMA",
      title: "Cebinizdeki ön muhasebe.",
      desc: "Android'de Google Play aboneliği, biyometrik giriş ve uygulama kilidi; fiş okuma yapay zekâ ile gideri otomatik oluşturur.",
      note: "Ana planlar web ve Google Play üzerinden alınabilir; modüller paketlere dahildir.",
      stores: ["App Store", "Google Play"],
      alts: ["Parasyo mobil panel ekranı", "Parasyo mobil kasa ve banka ekranı", "Parasyo mobil stok ekranı"],
      highlights: ["Google Play aboneliği", "Parmak izi / yüz ile giriş", "Uygulama kilidi", "Yapay zekâ ile fiş okuma", "150+ para birimi ve canlı TCMB kuru", "TR/EN/AR/AZ dil desteği", "Altın ve maden takibi"],
    },
    pricing: {
      kicker: "FİYATLANDIRMA",
      title: "Basit ve şeffaf.",
      sub: "Kurulum ücreti yok. İstediğiniz zaman yükseltin, istediğiniz zaman ayrılın.",
      monthly: "/ay",
      popular: "EN POPÜLER",
      cta: "Hemen Başla",
      plans: [
        { name: "ParasyoFree", price: "Ücretsiz", desc: "Bireysel başlangıç", features: ["40 hesap slotu", "Temel gelir-gider", "Fiş okuma", "Raporlar"] },
        { name: "Plus", price: "₺90", desc: "Birey & aile · Home+ dahil", features: ["550 slot", "Çek/senet", "Home+", "Öncelikli destek"] },
        { name: "Premium", price: "₺299", desc: "Esnaf & küçük işletme", features: ["POS ve veresiye", "Stok ve kasa", "Personel ve raporlar", "KDV ve e-Fatura dahil"] },
        { name: "Pro", price: "₺499", desc: "Kurumsal paket", features: ["Premium'daki her şey", "CRM · DMS · İK+ · PDKS", "10 kullanıcı", "15 özel rol", "3 şirket"] },
      ],
    },
    blog: {
      kicker: "BLOG",
      title: "İşletme yönetimine dair notlar.",
      readMore: "Okumaya devam et",
      posts: [
        { date: "12 Temmuz 2026", cat: "NAKİT AKIŞI", title: "KOBİ'lerde nakit akışı krizini önlemenin 5 yolu", excerpt: "Kâğıt üzerinde kârlı görünen işletmeler neden batar? Cevap çoğu zaman nakit akışı disiplininde gizli." },
        { date: "28 Haziran 2026", cat: "VERİMLİLİK", title: "Excel'den ön muhasebe yazılımına geçiş rehberi", excerpt: "Hangi verileri taşımalı, hangilerini geride bırakmalı? Geçiş sürecini iki haftada tamamlamanın yolları." },
        { date: "9 Haziran 2026", cat: "EKİP YÖNETİMİ", title: "İzin takibinde dijitalleşme: İK'nın görünmeyen maliyeti", excerpt: "Manuel izin takibi yapan bir işletme yılda kaç saat kaybeder? Hesapladık." },
      ],
    },
    faq: {
      kicker: "SSS",
      title: "Merak edilenler.",
      items: [
        { q: "Parasyo fatura kesiyor mu?", a: "Hayır. Parasyo bir ön muhasebe platformudur; cari hesap, gelir-gider, stok, CRM, İK, belge ve teklif yönetimini kapsar. e-Fatura/e-Arşiv süreçlerinizi mevcut mali müşaviriniz veya entegre çözümünüzle yürütmeye devam edersiniz." },
        { q: "Verilerim güvende mi?", a: "Tüm verileriniz şifrelenmiş bağlantı üzerinden aktarılır ve Türkiye'deki veri merkezlerinde yedeklenir. Rol bazlı yetkilendirme ile her kullanıcı yalnızca kendi yetki alanını görür." },
        { q: "Kurulum ne kadar sürer?", a: "Ortalama kurulum süresi 15 dakikadır. Mevcut Excel veya yazılım verilerinizi içe aktarma aracımızla taşıyabilirsiniz; destek ekibimiz bu süreçte yanınızdadır." },
        { q: "7/24 destek gerçekten canlı mı?", a: "Evet. Chatbot değil, gerçek ürün uzmanları. Gece, hafta sonu ve resmi tatiller dahil ortalama yanıt süremiz 3 dakikanın altındadır." },
        { q: "İstediğim zaman iptal edebilir miyim?", a: "Elbette. Taahhüt yok, cayma bedeli yok. Verilerinizi iptal sonrasında dahi 90 gün boyunca dışa aktarabilirsiniz." },
      ],
    },
    solutions: {
      kicker: "ÇÖZÜMLER",
      title: "Her işletmeye göre şekillenir.",
      sub: "Perakendeden üretime, Parasyo işletmenizin çalışma biçimine uyum sağlar.",
      items: [
        { title: "Perakende & Mağazacılık", desc: "Stok, kasa ve müşteri takibi tek ekranda. Gün sonu raporu tek tıkla." },
        { title: "E-Ticaret", desc: "Pazaryeri satışları, iade hareketleri ve kargo maliyetleri gelir-gider tablonuzda." },
        { title: "Hizmet & Ajans", desc: "Proje bazlı teklif, tahsilat ve belge yönetimi. Müşteri bazlı kârlılık görünümü." },
        { title: "Üretim & Toptan", desc: "Çok depolu stok, vade takibi ve tedarikçi cari yönetimi." },
        { title: "Kafe & Restoran", desc: "Günlük kasa, malzeme stoğu ve personel vardiya takibi." },
        { title: "Serbest Çalışan", desc: "Gelir-gider, teklif ve belge arşivi. Muhasebecinizle veri paylaşımı." },
      ],
    },
    how: {
      kicker: "NASIL ÇALIŞIR",
      title: "15 dakikada yayında.",
      sub: "Kurulum için teknisyen gerekmez. Dört adımda işletmeniz dijitale taşınır.",
      steps: [
        { title: "Hesabını oluştur", desc: "E-postanla kaydol, işletme bilgilerini gir. Kredi kartı gerekmez." },
        { title: "Verilerini aktar", desc: "Excel cari ve stok listelerini içe aktarma aracıyla taşı." },
        { title: "Ekibini davet et", desc: "Rol bazlı yetkilerle muhasebe, satış ve depo ekibini ekle." },
        { title: "Yönetmeye başla", desc: "Nakit akışı, stok ve müşteriler artık tek panelde." },
      ],
    },
    compare: {
      kicker: "KARŞILAŞTIRMA",
      title: "Neden Parasyo?",
      sub: "Excel ve geleneksel muhasebe programlarıyla yan yana koyduk.",
      cols: ["Parasyo", "Excel", "Geleneksel Program"],
      rows: [
        { label: "Gelir-gider takibi", values: [true, true, true] },
        { label: "Stok yönetimi", values: [true, "Kısmi", true] },
        { label: "CRM", values: [true, false, "Ek ücret"] },
        { label: "İnsan kaynakları", values: [true, false, "Ek ücret"] },
        { label: "Teklif yönetimi", values: [true, false, true] },
        { label: "Belge arşivi", values: [true, false, false] },
        { label: "7/24 canlı destek", values: [true, false, "Mesai saatleri"] },
        { label: "Kurulum süresi", values: ["15 dk", "—", "Günler"] },
      ],
    },
    testimonials: {
      kicker: "REFERANSLAR",
      title: "İşletmeler ne diyor?",
      items: [
        { quote: "Üç şubemizin kasasını artık telefondan takip ediyorum. Vadesi geçen alacaklar için gelen uyarılar tahsilat hızımızı ciddi artırdı.", name: "Serkan A.", role: "Perakende Zinciri Sahibi" },
        { quote: "Excel kaosundan çıktık. Tekliften tahsilata kadar her şey aynı yerde; muhasebecimle ay sonu mesaimiz yarıya indi.", name: "Elif K.", role: "Ajans Kurucusu" },
        { quote: "Gece 23.00'te destek yazdım, 2 dakikada gerçek bir insan yanıtladı. Bu alışkanlık yapıyor.", name: "Murat D.", role: "E-ticaret İşletmecisi" },
      ],
    },
    integrations: {
      kicker: "ENTEGRASYONLAR",
      title: "Araçlarınızla konuşur.",
      sub: "Ödeme altyapısından iletişim kanallarına, Parasyo ekosistemine bağlanır.",
      items: [
        { name: "iyzico", desc: "Online tahsilat" },
        { name: "WhatsApp Business", desc: "Müşteri bildirimleri" },
        { name: "Açık Bankacılık", desc: "Banka hareketleri" },
        { name: "E-posta (SMTP)", desc: "Otomatik yazışmalar" },
      ],
      note: "Yeni entegrasyonlar her ay ekleniyor.",
    },
    form: {
      kicker: "İLETİŞİM",
      title: "Bize ulaşın.",
      sub: "Sorularınız için formu doldurun; ekibimiz aynı gün içinde size dönsün. Parasyo ücretsizdir — ücretli planlarımız ekstra özellikler sunar.",
      name: "Ad Soyad",
      email: "E-posta",
      phone: "Telefon (opsiyonel)",
      message: "Mesajınız",
      submit: "Gönder",
      sending: "Gönderiliyor...",
      successTitle: "Mesajınız alındı",
      successDesc: "Ekibimiz en kısa sürede size dönüş yapacak.",
      errorTitle: "Bir hata oluştu",
      errorDesc: "Lütfen bilgilerinizi kontrol edip tekrar deneyin.",
    },
    support: {
      kicker: "CANLI DESTEK",
      title: "Gerçek ürün uzmanıyla yazışın.",
      desc: "Ad, e-posta, telefon (isteğe bağlı), konu ve mesajınızı paylaşın; üyelik gerekmez.",
      auto: "Şirket e-postanızla yazarsanız sistem sizi otomatik olarak müşteri olarak tanır.",
      button: "Canlı Destek",
      hint: "Yardıma mı ihtiyacın var?",
      panelTitle: "Parasyo Canlı Destek",
      panelSub: "Üyelik gerekmez · Gerçek ürün uzmanları",
      privacy: "Gizlilik Politikası",
      close: "Kapat",
    },
    footer: {
      tagline: "Kişisel bütçe, ev ve iş finans asistanı.",
      product: "Ürün",
      company: "Şirket",
      legal: "Yasal",
      links: { features: "Özellikler", pricing: "Fiyatlandırma", blog: "Blog", demo: "İletişim", about: "Hakkımızda", contact: "İletişim", privacy: "Gizlilik Politikası", terms: "Kullanım Koşulları", distance: "Mesafeli Satış Sözleşmesi", delivery: "Teslimat ve İade" },
      rights: "© 2026 Parasyo. Tüm hakları saklıdır.",
    },
  },
  en: {
    nav: {
      features: "Features",
      modules: "Modules",
      pricing: "Pricing",
      blog: "Blog",
      faq: "FAQ",
      online: "Web Branch",
      login: "Log In",
      register: "Sign Up",
    },
    segments: { individual: "Personal & Business", corporate: "Corporate" },
    hero: {
      overline: "PARASYO · FINANCE ASSISTANT",
      line1: "Personal budget, home & business",
      line2: "finance assistant.",
      sub: "Personal budget, home (Home+) and business finances in one app. Accounts, budgets, stock, quotes and reports — with 24/7 live support.",
      slide2: {
        line1: "Personal and business,",
        line2: "one platform.",
        desc: "From ParasyoFree to Pro — personal finance, Home+ and business operations in one account. Choose only Personal & Business or Corporate during signup.",
        cta: "Explore Features",
      },
      ctaPrimary: "Start Free",
      ctaSecondary: "Discover Parasyo",
      note: "No credit card required · Upgrade anytime",
      stats: [
        { value: "12,000+", label: "active businesses" },
        { value: "99.9%", label: "uptime" },
        { value: "24/7", label: "live support" },
      ],
      card: {
        title: "Cash Flow",
        month: "July 2026",
        income: "Income",
        expense: "Expense",
        balance: "Net Balance",
      },
    },
    marquee: [
      "INCOME & EXPENSE TRACKING",
      "INVENTORY MANAGEMENT",
      "FAST SALE (POS)",
      "FX ACCOUNTS",
      "CHECK & NOTE TRACKING",
      "STAFF & HR",
      "REPORTS & STATEMENTS",
      "24/7 SUPPORT",
      "E-INVOICE (COMING SOON)",
    ],
    manifesto: {
      kicker: "MANIFESTO",
      title: "Accounting isn't a burden. It's a matter of visibility.",
      body: "Parasyo brings your business's financial operations — from income and expenses to stock, staff and proposals — onto a single screen. It works on web and mobile: start free with no credit card, upgrade anytime.",
    },
    features: {
      kicker: "FEATURES",
      title: "The heart of your business,",
      titleAccent: "on one platform.",
      sub: "Eight powerful modules. One platform. Zero chaos.",
      sub_individual: "Simple, powerful tools for freelancers and sole proprietors.",
      sub_corporate: "Full control for growing businesses with Pro.",
      soon: "COMING SOON",
      detail: "Explore",
      items: [
        { no: "01", title: "Pre-Accounting", desc: "Current accounts, cash and bank movements, collections and payments. The financial heart of your business, always current." },
        { no: "02", title: "Income-Expense Tracking", desc: "Category-based analysis, period comparisons and cash-flow foresight." },
        { no: "03", title: "Inventory Management", desc: "Low-stock alerts, warehouse-level tracking and automatic count reports." },
        { no: "04", title: "CRM", desc: "Customer history, sales pipeline and communication logs unified on a single card." },
        { no: "05", title: "Human Resources", desc: "Employee records, leave tracking and payroll preparation." },
        { no: "06", title: "Document Management", desc: "Contracts, receipts and paperwork — tagged, searchable and secure." },
        { no: "07", title: "Proposal Management", desc: "Prepare professional proposals in minutes, track approvals in real time." },
        { no: "08", title: "24/7 Live Support", desc: "Real humans, real-time answers. Even at 3 a.m." },
      ],
    },
    modules: {
      kicker: "REAL SCREENS",
      rows: [
        {
          tag: "01 — CASH, BANK & ACCOUNTS",
          title: "All money movement on one screen.",
          desc: "Unlimited cash and bank accounts, automatic TL equivalents with CBRT rates on FX accounts, check/note tracking and read-only statement sharing.",
          points: ["FX accounts + cross-currency transfers", "Check & note maturity tracking", "Read-only sharing links"],
          img: "web-kasa-banka",
          alt: "Parasyo cash and bank screen",
          slug: "on-muhasebe",
        },
        {
          tag: "02 — INVOICES & PROPOSALS",
          title: "Invoices recorded, proposals tracked.",
          desc: "Record incoming and outgoing invoices with payment status; prepare customer-specific proposals and track approvals.",
          points: ["Invoice recording and status tracking", "Proposal-to-sale conversion", "Supplier and project linkage"],
          img: "web-faturalar",
          alt: "Parasyo invoices screen",
          slug: "teklif-yonetimi",
        },
        {
          tag: "03 — INVENTORY",
          title: "Low stock, right before your eyes.",
          desc: "Product cards, multi-warehouse support, stock movements and low-stock alerts. Brand and category dictionaries: write once, pick from the list.",
          points: ["Low-stock alerts", "Multi-warehouse and movement history", "Brand/category dictionaries"],
          img: "web-stok",
          alt: "Parasyo inventory screen",
          slug: "stok-yonetimi",
        },
        {
          tag: "04 — FAST SALE (POS)",
          title: "Counter sales take seconds.",
          desc: "Barcode sales, register open/close, tabs and end-of-day. Included in the Premium and Pro plans.",
          points: ["Fast barcode sales", "Register open/close control", "Tab collections"],
          img: "web-pos",
          phone: "mobil-pos",
          alt: "Parasyo fast sale POS screen",
          slug: "hizli-satis",
        },
        {
          tag: "05 — STAFF, HR+ & ATTENDANCE",
          title: "Your team's records in order.",
          desc: "Staff cards, salary and pay-day tracking; clock-in/out and timesheets with Pro's attendance module.",
          points: ["Staff cards and paydays", "Attendance and timesheets", "HR+ advanced staff management"],
          img: "web-personel",
          alt: "Parasyo staff management screen",
          slug: "insan-kaynaklari",
        },
        {
          tag: "06 — REPORTS & CHECKS/NOTES",
          title: "Decisions backed by data.",
          desc: "Periodic reports, statement downloads and the maturity view of your check/note portfolio.",
          points: ["Report and statement downloads", "Check/note maturity calendar", "Period comparisons"],
          img: "web-raporlar",
          alt: "Parasyo reports screen",
          slug: "gelir-gider-takibi",
        },
        {
          tag: "07 — CRM",
          title: "The customer's story on one card.",
          desc: "Advanced CRM is included in Pro: customer cards, sales tracking and reminders.",
          points: ["360° customer card", "Sales tracking", "Automatic reminders"],
          img: "web-crm",
          alt: "Parasyo CRM screen",
          slug: "crm",
        },
      ],
    },
    mobile: {
      kicker: "MOBILE APP",
      title: "Pre-accounting in your pocket.",
      desc: "Google Play subscriptions, biometric sign-in and app lock on Android; AI receipt scanning creates expenses automatically.",
      note: "Main plans are available on the web and Google Play; modules are included in the plans.",
      stores: ["App Store", "Google Play"],
      alts: ["Parasyo mobile dashboard", "Parasyo mobile cash and bank screen", "Parasyo mobile inventory screen"],
      highlights: ["Google Play subscription", "Fingerprint / face sign-in", "App lock", "AI receipt scanning", "150+ currencies and live CBRT rates", "TR/EN/AR/AZ language support", "Gold and commodity tracking"],
    },
    pricing: {
      kicker: "PRICING",
      title: "Simple and transparent.",
      sub: "No setup fee. Upgrade anytime, leave anytime.",
      monthly: "/mo",
      popular: "MOST POPULAR",
      cta: "Get Started",
      plans: [
        { name: "ParasyoFree", price: "Free", desc: "Personal start", features: ["40 account slots", "Core income/expense", "Receipt scanning", "Reports"] },
        { name: "Plus", price: "$2.90", desc: "Individuals & family · Home+ included", features: ["550 slots", "Cheques/notes", "Home+", "Priority support"] },
        { name: "Premium", price: "$8.90", desc: "Shopkeepers & small business", features: ["POS and tabs", "Stock and cash desk", "Staff and reports", "VAT and e-Invoice included"] },
        { name: "Pro", price: "$14.90", desc: "Corporate plan", features: ["Everything in Premium", "CRM · DMS · HR+ · Attendance", "10 users", "15 custom roles", "3 companies"] },
      ],
    },
    blog: {
      kicker: "BLOG",
      title: "Notes on running a business.",
      readMore: "Keep reading",
      posts: [
        { date: "July 12, 2026", cat: "CASH FLOW", title: "5 ways to prevent a cash-flow crisis in your SMB", excerpt: "Why do businesses that look profitable on paper go under? The answer usually hides in cash-flow discipline." },
        { date: "June 28, 2026", cat: "PRODUCTIVITY", title: "The migration guide: from Excel to pre-accounting software", excerpt: "Which data should you migrate, which should you leave behind? How to complete the switch in two weeks." },
        { date: "June 9, 2026", cat: "TEAM MANAGEMENT", title: "Digitizing leave tracking: HR's invisible cost", excerpt: "How many hours a year does a business lose tracking leave manually? We did the math." },
      ],
    },
    faq: {
      kicker: "FAQ",
      title: "Common questions.",
      items: [
        { q: "Does Parasyo issue invoices?", a: "No. Parasyo is a pre-accounting platform covering current accounts, income/expense, inventory, CRM, HR, documents and proposals. You keep running e-invoicing with your accountant or integrated solution." },
        { q: "Is my data secure?", a: "All data is transferred over encrypted connections and backed up in data centers in Türkiye. Role-based permissions ensure each user only sees their own scope." },
        { q: "How long does setup take?", a: "15 minutes on average. Import your existing Excel or software data with our import tool — our support team is with you along the way." },
        { q: "Is 24/7 support really live?", a: "Yes. Real product experts, not chatbots. Nights, weekends and holidays included — our average response time is under 3 minutes." },
        { q: "Can I cancel anytime?", a: "Of course. No commitment, no cancellation fee. You can export your data for 90 days even after cancelling." },
      ],
    },
    solutions: {
      kicker: "SOLUTIONS",
      title: "Shaped around your business.",
      sub: "From retail to manufacturing, Parasyo adapts to how you work.",
      items: [
        { title: "Retail & Stores", desc: "Stock, cash register and customer tracking on one screen. End-of-day report in one click." },
        { title: "E-Commerce", desc: "Marketplace sales, returns and shipping costs flow into your income-expense view." },
        { title: "Services & Agencies", desc: "Project-based proposals, collections and documents. Profitability per customer." },
        { title: "Manufacturing & Wholesale", desc: "Multi-warehouse stock, maturity tracking and supplier accounts." },
        { title: "Cafes & Restaurants", desc: "Daily register, ingredient stock and staff shift tracking." },
        { title: "Freelancers", desc: "Income-expense, proposals and document archive. Data sharing with your accountant." },
      ],
    },
    how: {
      kicker: "HOW IT WORKS",
      title: "Live in 15 minutes.",
      sub: "No technician needed. Your business goes digital in four steps.",
      steps: [
        { title: "Create your account", desc: "Sign up with your email, enter your business details. No credit card required." },
        { title: "Import your data", desc: "Bring your Excel customer and stock lists with the import tool." },
        { title: "Invite your team", desc: "Add accounting, sales and warehouse staff with role-based permissions." },
        { title: "Start managing", desc: "Cash flow, stock and customers — now in one panel." },
      ],
    },
    compare: {
      kicker: "COMPARISON",
      title: "Why Parasyo?",
      sub: "Side by side with Excel and traditional accounting software.",
      cols: ["Parasyo", "Excel", "Traditional Software"],
      rows: [
        { label: "Income-expense tracking", values: [true, true, true] },
        { label: "Inventory management", values: [true, "Partial", true] },
        { label: "CRM", values: [true, false, "Extra fee"] },
        { label: "Human resources", values: [true, false, "Extra fee"] },
        { label: "Proposal management", values: [true, false, true] },
        { label: "Document archive", values: [true, false, false] },
        { label: "24/7 live support", values: [true, false, "Business hours"] },
        { label: "Setup time", values: ["15 min", "—", "Days"] },
      ],
    },
    testimonials: {
      kicker: "TESTIMONIALS",
      title: "What businesses say.",
      items: [
        { quote: "I now track the registers of my three branches from my phone. Overdue-receivable alerts seriously sped up our collections.", name: "Serkan A.", role: "Retail Chain Owner" },
        { quote: "We escaped the Excel chaos. Everything from proposal to collection is in one place; month-end work with our accountant halved.", name: "Elif K.", role: "Agency Founder" },
        { quote: "I messaged support at 11 p.m. and a real human replied in 2 minutes. It's habit-forming.", name: "Murat D.", role: "E-commerce Operator" },
      ],
    },
    integrations: {
      kicker: "INTEGRATIONS",
      title: "Talks to your tools.",
      sub: "From payment infrastructure to communication channels, Parasyo connects to your ecosystem.",
      items: [
        { name: "iyzico", desc: "Online collections" },
        { name: "WhatsApp Business", desc: "Customer notifications" },
        { name: "Open Banking", desc: "Bank transactions" },
        { name: "Email (SMTP)", desc: "Automatic correspondence" },
      ],
      note: "New integrations added every month.",
    },
    form: {
      kicker: "CONTACT",
      title: "Get in touch.",
      sub: "Fill in the form and our team will get back to you the same day. Parasyo is free — our paid plans simply add extra features.",
      name: "Full Name",
      email: "Email",
      phone: "Phone (optional)",
      message: "Your message",
      submit: "Send",
      sending: "Sending...",
      successTitle: "Message received",
      successDesc: "Our team will get back to you shortly.",
      errorTitle: "Something went wrong",
      errorDesc: "Please check your details and try again.",
    },
    support: {
      kicker: "LIVE SUPPORT",
      title: "Chat with a real product expert.",
      desc: "Share your name, email, phone (optional), subject and message — no account required.",
      auto: "If you write from your company email, the system automatically recognizes you as a customer.",
      button: "Live Support",
      hint: "Need help?",
      panelTitle: "Parasyo Live Support",
      panelSub: "No account required · Real product experts",
      privacy: "Privacy Policy",
      close: "Close",
    },
    footer: {
      tagline: "Your personal, home & business finance assistant.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      links: { features: "Features", pricing: "Pricing", blog: "Blog", demo: "Contact", about: "About", contact: "Contact", privacy: "Privacy Policy", terms: "Terms", distance: "Distance Sales Agreement", delivery: "Delivery & Refunds" },
      rights: "© 2026 Parasyo. All rights reserved.",
    },
  },
};

const LangContext = createContext(null);

const LANG_STORAGE_KEY = "parasyo-lang";
const GEO_STORAGE_KEY = "parasyo-geo";

export const LangProvider = ({ children }) => {
  // Dil tercihi kalıcıdır; coğrafi tespit yalnızca henüz tercih yoksa varsayılanı belirler.
  // Kural: Türkiye -> TR + TL, diğer ülkeler (ve tespit edilemeyenler) -> EN + $ fiyatlar.
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem(LANG_STORAGE_KEY) || "tr"; } catch { return "tr"; }
  });
  const [isForeign, setIsForeign] = useState(false);
  const [geoResolved, setGeoResolved] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const applyGeo = (g) => {
      if (cancelled) return;
      // is_tr açıkça false değilse Türkiye varsay (tespit edilemeyen ziyaretçi TR görür).
      // Dil yönlendirmesini URL'ye göre LangSync yapar (App.js); burada yalnızca tespit tutulur.
      const foreign = !g || g.is_tr === false;
      setIsForeign(foreign);
      setGeoResolved(true);
    };
    try {
      const cached = sessionStorage.getItem(GEO_STORAGE_KEY);
      if (cached) {
        applyGeo(JSON.parse(cached));
        return () => { cancelled = true; };
      }
    } catch { /* yoksay */ }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/geo`)
      .then((r) => r.json())
      .then((g) => {
        const data = { country: g.country || null, is_tr: g.is_tr !== false };
        try { sessionStorage.setItem(GEO_STORAGE_KEY, JSON.stringify(data)); } catch { /* yoksay */ }
        applyGeo(data);
      })
      .catch(() => applyGeo(null));
    return () => { cancelled = true; };
  }, []);

  const setLang = (l) => {
    try { localStorage.setItem(LANG_STORAGE_KEY, l); } catch { /* yoksay */ }
    setLangState(l);
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang], isForeign, geoResolved }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
